<template>
  <div>
    <template v-if="$auth.check()">
      <!-- <ModalWelcome /> -->
      <IcebreakerSend />

      <template v-if="isAdmin">
        <UserBan />
        <UserDebug />
        <UserDelete />
        <UserDeleteData />
        <UserDisable />
        <UserGhostMessage />
        <UserLogout />
        <UserReport />
      </template>
    </template>
  </div>
</template>

<script>
import permissions from '@/mixins/permissions';

export default {
  components: {
    // user modals
    IcebreakerSend: () => import(/* webpackChunkName: "components--user-modals" */ '@/components/modals/user/IcebreakerSend'),

    // admin modals
    UserBan: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserBan'),
    UserDebug: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserDebug'),
    UserDelete: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserDelete'),
    UserDeleteData: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserDeleteData'),
    UserDisable: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserDisable'),
    UserGhostMessage: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserGhostMessage'),
    UserLogout: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserLogout'),
    UserReport: () => import(/* webpackChunkName: "components--admin-modals" */ '@/components/modals/admin/UserReport'),
  },

  mixins: [
    permissions, //
  ],

  data() {
    return {};
  },

  created() {
    // this.setupEventListeners();
  },

  mounted() {
    Bus.$on('show_ok_box', (options) => {
      console.log('show_ok_box', options);
      this.$bvModal
        .msgBoxOk(this.htmlToVNode(this.ucfirst(options.body)), {
          titleHtml: this.ucfirst(options.title),
          size: options.size || 'sm',
          buttonSize: options.buttonSize || 'sm',
          okVariant: options.okVariant || 'success',
          headerClass: options.headerClass || 'p-2 border-bottom-0',
          footerClass: options.footerClass || 'p-2 border-top-0',
          centered: options.centered || true,
        })
        .then((/* value */) => {
          // console.log('show_ok_box.then.value', value);
        })
        .catch((/* error */) => {
          // console.log('show_ok_box.catch.error', error);
        });
    });

    Bus.$on('show_confirm_box', (options) => {
      this.$bvModal
        .msgBoxConfirm(this.htmlToVNode(this.ucfirst(options.body)), {
          title: this.ucfirst(options.title),
          size: options.size || 'sm',
          buttonSize: options.buttonSize || 'sm',
          okVariant: options.okVariant || 'danger',
          okTitle: this.ucfirst(options.okTitle || 'ok'),
          cancelTitle: this.ucfirst(options.cancelTitle || this.$i18n.t('JSON.cancel')),
          headerClass: options.headerClass || 'p-2',
          footerClass: options.footerClass || 'p-2',
          hideHeaderClose: options.hideHeaderClose || false,
          centered: options.centered || true,
          cancelDisabled: options.cancelDisabled || true,
        })
        .then((value) => {
          if (options.hookThen) {
            options.hookThen(value);
          } else {
            console.log('missing then hook');
          }
        })
        .catch((err) => {
          if (options.hookCatch) {
            options.hookCatch(err);
          } else {
            console.log('missing catch hook', err);
          }
        });
    });
  },

  beforeDestroy() {
    // Bus.$off('modal:toggle_with_model');
    // Bus.$off('modal:set-model-id');
    Bus.$off('show_ok_box');
    Bus.$off('show_confirm_box');
  },

  methods: {
    // setupEventListeners() {
    //   Bus.$on('modal:toggle_with_model', (modal, modelId) => {
    //     // console.log('modals.modal:toggle', modal, modelId);
    //     Bus.$emit('modal:set-model-id', modal, modelId);
    //     Bus.$emit('modal:toggle', modal);
    //   });

    //   Bus.$on('modal:set-model-id', (modal, modelId) => {
    //     // console.log(`setting ${modal}Id to ${modelId}`);
    //     this[`${modal}Id`] = modelId;
    //   });
    // },

    htmlToVNode(html) {
      return [this.$createElement('div', { domProps: { innerHTML: html } })];
    },
  },
};
</script>
